import { BaseComponent } from '../../base-component';
import { EventCallback } from '@otto-ec/global-resources/event-q-bus';
import { calcInstallmentRate } from '../../_common/server/installment-plan';
import { CalculationHelpers } from '../../_common/client/calculation-helpers';
import { EFFECTIVE_PRICE_CHANGED_TOPIC, EffectivePriceChangeEvent, getRenderedEffectivePrice } from '../../price/client/effective-price';

export class InstallmentPlanExampleComponent extends BaseComponent {
    public rootSelector = '.js_pdp_installment-plan-example';
    public priceSelector = '.js_pdp_installment-plan-example__example-price';
    private priceChangeListener?: EventCallback<[EffectivePriceChangeEvent]> | null;

    public async onHtmlLoaded(): Promise<void> {
        if (this.priceChangeListener) {
            o_global.eventQBus.off(EFFECTIVE_PRICE_CHANGED_TOPIC, this.priceChangeListener);
        }

        if (!this.isPresent()) {
            return;
        }

        const rootElement = this.getRootElement();
        this.priceChangeListener = o_global.eventQBus.on(EFFECTIVE_PRICE_CHANGED_TOPIC, event => {
            if (rootElement.isConnected) {
                this.updatePrice(event, rootElement);
            }
        });

        const effectivePrice = getRenderedEffectivePrice();
        if (effectivePrice) {
            this.updatePrice(effectivePrice, rootElement);
        }
    }

    private updatePrice(event: EffectivePriceChangeEvent, rootElement: HTMLElement): void {
        if (!event.variationId || event.variationId !== rootElement.dataset.variationId) {
            return;
        }

        const duration = Number(rootElement.dataset.duration);
        const surcharge = Number(rootElement.dataset.surcharge);
        if (!Number.isFinite(duration) || !Number.isFinite(surcharge)) {
            throw new Error('installment config could not be read from data attributes');
        }

        const monthlyRate = calcInstallmentRate({ duration, surcharge }, event.newPriceCents);
        this.updateText(rootElement, this.priceSelector, `${CalculationHelpers.convertFloatToString(monthlyRate)} €`);
    }

    private updateText(htmlRootElement: HTMLElement, selector: string, text: string) {
        const htmlElement = htmlRootElement.querySelector<HTMLElement>(selector);
        if (!htmlElement) {
            throw new Error(`${selector} could not be found`);
        }

        htmlElement.innerText = text;
    }
}
